/**
 * Lookup values for Internal Affairs module
 *
 * These values represent the unique values that can be used when generating mock data.
 */

/**
 * Unique values for DisciplinaryAction (top 15 most used)
 */
export const DISCIPLINARY_ACTION_VALUES: readonly string[] = [
  'Written Reprimand',
  'None',
  'Written Warning',
  'Suspension',
  'Termination',
  'No Action Taken',
  'Verbal Warning',
  'Counseling',
  'Disciplinary Action',
  'Suspension without Pay',
  'Other',
] as const;

/**
 * Unique values for Disposition (top 15 most used)
 */
export const DISPOSITION_VALUES: readonly string[] = [
  'Sustained',
  'Unfounded',
  'Exonerated',
  'Not Sustained',
  'Other',
  'Administrative Closure',
  'Closed',
  'No Factual Basis',
  'Justified',
] as const;

/**
 * Unique values for IncidentType (top 15 most used)
 */
export const INCIDENT_TYPE_VALUES: readonly string[] = [
  'Supervisory Inquiry',
  'Internal Affairs',
  'Civilian Complaint',
  'Departmental Complaint',
  'Citizen Complaint',
  'Litigation',
  'Administrative Investigation',
  'Supervisor Complaint',
  'Counseling',
  'Documented Counseling',
  'Civilian complaint',
  'Use of force',
  'IOD-Light Duty',
  'I.A. Investigation',
  'Informal Investigation',
] as const;

/**
 * Unique values for CaseType (top 15 most used)
 */
export const CASE_TYPE_VALUES: readonly string[] = [
  'Administrative',
  'Supervisory Investigation',
  'Formal',
  'Discipline/Counsel',
  'Citizen Complaint',
  'External Complaint',
  'CRB',
  'Internal',
  'Internal Complaint',
  'Administrative Investigation',
  'Internal Investigation',
  'Informal Inquiry',
  'Inquiries',
] as const;

/**
 * Unique values for ComplaintNature (top 15 most used)
 */
export const COMPLAINT_NATURE_VALUES: readonly string[] = [
  'Policy Violation',
  'Performance',
  'Conduct',
  'Excessive Force',
  'Use of Force',
  'Code of Conduct',
  'Neglect of Duty',
  'Conduct Unbecoming',
  'Rudeness',
  'Insufficient Probable Cause',
  'Standards of Conduct',
  'Driving Complaint',
  'Efficiency',
  'Other',
  'Dishonesty',
] as const;
